import { MutableRefObject, useState } from 'react';
import { Editor } from 'tinymce';
import { GroupItems } from '../../../../shared/autocomplete-groups-ui';
import { UseFormGetValues, UseFormSetValue } from 'react-hook-form';
import { WelcomeTemplateFormValues } from './welcome-templates-form-page';
import Autocomplete from '@mui/material/Autocomplete';
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
interface WelcomeFieldProps {
  editorRef?: MutableRefObject<Editor | null>;
  setValue?: UseFormSetValue<WelcomeTemplateFormValues>;
  getValues?: UseFormGetValues<WelcomeTemplateFormValues>;
  disabled?: boolean;
}

export default function WelcomeField({
  editorRef,
  setValue,
  getValues,
  disabled,
}: WelcomeFieldProps) {
  const [selectedField, setSelectedField] = useState('Email');
  const [gmailFieldBefore, setGmailFieldBefore] = useState('');
  const [gmailFieldAfter, setGmailFieldAfter] = useState('');
  const [gmailFieldConditionalError, setGmailFieldConditonalError] =
    useState(false);

  const fieldObject = [
    {
      type: 'profile',
      name: 'Email',
    },
    {
      type: 'profile',
      name: 'Domain',
    },
    {
      type: 'profile',
      name: 'First Name',
    },
    {
      type: 'profile',
      name: 'Last Name',
    },
    {
      type: 'profile',
      name: 'Password',
    },
    {
      type: 'profile',
      name: 'Groups',
    },
  ];

  const currentFieldIndex = fieldObject.findIndex(
    (field) => field.name === selectedField
  );

  function getCurrentTemplateString() {
    // remove spaces from field name
    const templateString = fieldObject[currentFieldIndex].name.replace(
      /\s/g,
      ''
    );
    return `{|${templateString}|}`;
  }

  return (
    <>
      <Stack flexDirection="row" gap={2} sx={{ mt: 3 }}>
        <Autocomplete
          id="grouped-values"
          autoComplete
          includeInputInList
          openOnFocus
          autoHighlight
          selectOnFocus
          options={fieldObject}
          groupBy={(option) => option.type}
          renderGroup={(params) => (
            <li key={params.key}>
              <GroupItems>{params.children}</GroupItems>
            </li>
          )}
          getOptionLabel={(option) => option.name}
          sx={{ width: 200 }}
          disabled={disabled}
          disableClearable
          renderInput={(params) => (
            <TextField {...params} label="Profile Field" />
          )}
          value={
            fieldObject.find((field) => field.name === selectedField) ||
            fieldObject[0]
          }
          isOptionEqualToValue={(option, value) => {
            return option.name === value?.name;
          }}
          onChange={(_event, newValue) => {
            setSelectedField(newValue?.name || '');
          }}
        />

        <Button
          variant="contained"
          sx={{ height: 'fit-content' }}
          disabled={disabled}
          onClick={() => {
            if (editorRef?.current) {
              editorRef.current.execCommand(
                'mceInsertContent',
                false,
                getCurrentTemplateString()
              );
            } else {
              if (setValue) {
                const currentValue = getValues?.('templateSubject') || '';
                setValue(
                  'templateSubject',
                  `${currentValue}${getCurrentTemplateString()}`
                );
              }
            }
          }}
        >
          Add
        </Button>
      </Stack>
      <Typography sx={{ fontSize: 14, fontWeight: 300, my: 1.5 }}>
        or Build Conditional
      </Typography>
      <Stack flexDirection="row" gap={1}>
        <TextField
          label="Before Field"
          value={gmailFieldBefore}
          onChange={(event) => {
            setGmailFieldBefore(event.target.value);
          }}
          error={gmailFieldConditionalError}
          disabled={disabled}
          helperText={
            gmailFieldConditionalError ? 'You must fill in one.' : ' '
          }
          sx={{ width: 200 }}
        ></TextField>
        <TextField
          label="Template Field:"
          value={getCurrentTemplateString()}
          disabled
          sx={{ width: 200 }}
        ></TextField>
        <TextField
          label="After Field"
          value={gmailFieldAfter}
          onChange={(event) => {
            setGmailFieldAfter(event.target.value);
          }}
          disabled={disabled}
          error={gmailFieldConditionalError}
          helperText={
            gmailFieldConditionalError ? 'You must fill in one.' : ' '
          }
          sx={{ width: 200 }}
        ></TextField>
        <Button
          sx={{ height: 'fit-content' }}
          variant="contained"
          disabled={disabled}
          onClick={() => {
            if (gmailFieldBefore.length === 0 && gmailFieldAfter.length === 0) {
              setGmailFieldConditonalError(true);
            } else {
              setGmailFieldConditonalError(false);

              let conditionString = getCurrentTemplateString() || '';

              if (conditionString.length > 0) {
                conditionString = conditionString.slice(2, -2);
              }

              conditionString = `${
                gmailFieldBefore.length > 0 ? `[|${gmailFieldBefore}` : '[|'
              }|${conditionString}|${
                gmailFieldAfter.length > 0 ? `${gmailFieldAfter}|]` : '|]'
              }`;

              if (editorRef?.current) {
                editorRef.current.execCommand(
                  'mceInsertContent',
                  false,
                  conditionString
                );
              } else {
                if (setValue) {
                  const currentValue = getValues?.('templateSubject') || '';
                  setValue(
                    'templateSubject',
                    `${currentValue}${conditionString}`
                  );
                }
              }
            }
          }}
        >
          Add
        </Button>
      </Stack>
    </>
  );
}
